// Global constants
export const NEW_OK_CANCEL_DIALOG = "okCancelDialog/CREATE_NEW";

// Local constants
export const SET_CONTENT = "SET_TITLE";
export const SHOW_DIALOG = "SHOW_DIALOG";
export const SET_RESOLVE = "SET_RESOLVE";
export const RESET_STATE = "RESET_STATE";
